import React, { useEffect, useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import moment from "moment";

//import {LeadFilterDataAPI, CallerAPI} from "./../../../API/Team/LeadAPI";
import {LeadFilterDataAPI} from "./../../API/Sales/LeadAPI";
import Sidebar from "./Common/Sidebar";
import Header from "./Common/Header";
import Loader from "./../Loader";
import Paginate from "./../../utils/Pagination";
//import { data } from "jquery";
import { ToastContainer } from 'react-toastify';
import { errorMesg } from "../Toaster";
import ReactSelect from 'react-select';


const LeadFilter = () =>{

    const {filtertype} = useParams();
    const [searchParam] = useSearchParams();

    const [leads, setLeads] = useState([]);
    //const [showleads, setShowLeads] = useState(true);
    const [loading, setLoading] = useState(false);
    const [btnloader, setBtnLoader] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pagecount, setPageCount] = useState(0);
    const [callers, setCallers] = useState([]);
    const [callername, setCallerName] = useState("");
    const [leadids, setLeadIDs] = useState([]);
    //const [isleadassign, setIsLeadAssign] = useState(false);
    const [programs, setPrograms] = useState([]);
    const [institute, setInstitute] = useState([]);
    const [selectedcallervalues, setSelectedCallerValues] = useState([]);
    const [selectedcaller, setSelectedCaller] = useState([]);
    const [filterprogram, setFilterProgram] = useState("");
    const [filterinstitute, setFilterInstitute] = useState("");

    const perpagedata = 20;

    const filterparams = new URLSearchParams();
    

    useEffect(() => {

        //CallerAPI(setCallers);
    }, []);

    useEffect(() => {

        console.log('search params====' + searchParam);        

        if(searchParam !== "" && searchParam !== null)
        {
            if(searchParam.get('team_id') !== "" && searchParam.get('team_id') !== null)
            {
                filterparams.append('filter_teamid', searchParam.get('team_id'));
            }

            if(searchParam.get('campaign_id') !== "" && searchParam.get('campaign_id') !== null)
            {
                filterparams.append('filter_campaignid', searchParam.get('campaign_id'));
            }

            if(searchParam.get('caller_id') !== "" && searchParam.get('caller_id') !== null)
            {
                filterparams.append('filter_callerid', searchParam.get('caller_id'));
            }

            if(searchParam.get('start_date') !== "" && searchParam.get('start_date') !== null)
            {
                filterparams.append('filter_startdate', searchParam.get('start_date'));
            }

            if(searchParam.get('end_date') !== "" && searchParam.get('end_date') !== null)
            {
                filterparams.append('filter_enddate', searchParam.get('end_date'));
            }

            if(searchParam.get('filterprogram') !== "" && searchParam.get('filterprogram') !== null)
            {
                filterparams.append('filterprogram', searchParam.get('filterprogram'));
            }

            if(searchParam.get('filterinstitute') !== "" && searchParam.get('filterinstitute') !== null)
            {
                filterparams.append('filterinstitute', searchParam.get('filterinstitute'));
            }

            if(currentPage)
            {
                filterparams.append('page', currentPage);
            }

            if(perpagedata)
            {
                filterparams.append('per_page', perpagedata);
            }
        }

        LeadFilterDataAPI(setLeads, setLoading, currentPage, perpagedata, setPageCount, filtertype, filterparams, setInstitute, setPrograms);

        //CallerAPI(setCallers);
        
        //setLeadIDs([]);

    }, [currentPage]);

    const handlePageClick = (data) =>{
        setCurrentPage(data.selected + 1);

        //setIsFilterPagination(true);

        //handleFilterLeads();
    }

    const handleCallerName = (selcaller) =>{
        console.log('>>>' + JSON.stringify(selcaller));
        
        if(selcaller)
        {
            let callervalue = selcaller.map(datalist => datalist.value);
            setSelectedCallerValues(callervalue);

            setSelectedCaller(selcaller);
        }
    }

    /*const handleLeadAssign = (e) =>{
        
        console.log('selected caller======' + JSON.stringify(selectedcaller));
        console.log('selected caller======' + selectedcaller.length);        

        //let assignedcaller = [];

        if(selectedcaller)
        {
            let callerdata = selectedcaller.map(callerlist => callerlist.value);

            //let assignedcaller = callerdata.split(",");

            //console.log('Assigned caller=====' + assignedcaller);
            //console.log('Assigned caller=====' + typeof assignedcaller);

            if(leadids.length > 0)
            {
                console.log('caller id===' + callerdata);    
                console.log('selected ids===' + leadids);    

                const params = {
                                'callerid': callerdata,
                                'leadids': leadids
                            };
                            
                //BulkLeadAssignCallerAPI(params, setIsLeadAssign, setFilterProgram, setFilterInstitute, setSelectedCaller);
            }
            else
            {
                errorMesg('Please select a lead to assign this caller');
                return;    
            }
        }
        else
        {
            errorMesg('Please select a caller');
            return;
        }

        
    }*/

    const handleSelectLead = (lid) =>{
        if(leadids.includes(lid))
        {
            setLeadIDs(leadids.filter(item => item !== lid));
        }
        else
        {
            setLeadIDs([...leadids, lid]);
        }
    }

    /*const handleSelectAllLeads = () =>{

        if(leadids.length === leads.length)
        {
            setLeadIDs([]);
        }
        else
        {
            setLeadIDs(leads.map(item => item.id));
        }
    }*/

    const handleProgram = (e) =>{
        setFilterProgram(e.target.value);
    }

    const handleInstitute = (e) =>{

        setFilterInstitute(e.target.value);
    }

    const handleLeadFilter = () =>{

        const filterparams = new URLSearchParams();
        
        if(filterprogram)
        {
            filterparams.append('filterprogram', filterprogram);
        }

        if(filterinstitute)
        {
            filterparams.append('filterinstitute', filterinstitute);
        }

        LeadFilterDataAPI(setLeads, setLoading, currentPage, perpagedata, setPageCount, filtertype, filterparams, setInstitute, setPrograms);
    }


    return(
    <div className="main-wrapper">
        <Loader />

        <Header />

        <Sidebar />

        <div className="page-wrapper">
            <div className="content">

                <div className="row">
                    <div className="col-md-12">

                        <div className="page-header">
                            <div className="row align-items-center">
                                <div className="col-12">
                                    {filtertype === 'freshlead' ?
                                        <h4 className="page-title">Fresh Leads</h4>
                                    :
                                        (filtertype === 'warmleads' ?
                                            <h4 className="page-title">Warm Leads</h4>
                                        :
                                            (filtertype === 'contactedleads' ?
                                                <h4 className="page-title">Contacted Leads</h4>
                                            :
                                                (filtertype === 'deadleads' ?
                                                    <h4 className="page-title">Dead Leads</h4>
                                                :
                                                    (filtertype === 'coldleads' ?
                                                        <h4 className="page-title">Cold Leads</h4>
                                                    :
                                                        (filtertype === 'attemptleads' ?
                                                            <h4 className="page-title">Attempt to Contact Leads</h4>
                                                        :
                                                            (filtertype === 'enrolledleads' ?
                                                                <h4 className="page-title">Enrolled Leads</h4>
                                                            :
                                                                (filtertype === 'totalleads' ?
                                                                    <h4 className="page-title">Total Leads</h4>
                                                                :
                                                                    <></>    
                                                                )   
                                                            )   
                                                        )   
                                                    )   
                                                )
                                            )
                                        )
                                    }
                                </div>
                                <div className="col-2">
                                    <select className="form-select me-2" name="program" value={filterprogram} onChange={handleProgram }>
                                        <option value="">Select Program</option>
                                        {programs.map((programlist) =>
                                            (
                                                <option key={programlist} value={programlist}>{programlist}</option>
                                                
                                            ))                                        
                                        }
                                    </select>
                                </div>
                                <div className="col-2">
                                    <select className="form-select me-2" name="institute" value={filterinstitute} onChange={handleInstitute }>
                                        <option value="">Select Institute</option>
                                        {institute.map((institutelist) =>
                                            (
                                                <option key={institutelist} value={institutelist}>{institutelist}</option>
                                                
                                            ))                                        
                                        }
                                    </select>
                                </div>
                                <div className="col-2">
                                    <button type="button" className="btn btn-primary"  onClick={handleLeadFilter}>
                                        {btnloader ?
                                            <div className="spinner-border" role="status">
                                                <span className="sr-only">Loading...</span>
                                            </div>
                                        :
                                            <p>Filter Leads</p>
                                        }
                                    </button>
                                </div>                                
                                
                            </div>
                        </div>
                    </div>
                    
                    <div className="col-md-12">
                        <div className="card">

                            <div className="card-body">
                                                            
                                <div className="table-responsive custom-table">
                                    
                                    <table className="table" id="">
                                        <thead className="thead-light">
                                            <tr>
                                                <th>Name</th>
                                                <th>Email</th>
                                                <th>Contact</th>
                                                <th>Location</th>
                                                <th>Program</th>
                                                <th>Institute</th>
                                                <th>Source</th>
                                                {filtertype === 'freshlead' ?
                                                <th>Caller Name</th>
                                                :
                                                <th>Lead Status</th>
                                                }                                                
                                                <th>Created Date</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                    
                                        {loading ?
                                            <tr>
                                                <td colSpan="8">
                                                    <Loader />
                                                </td>
                                            </tr>
                                        :
                                            (leads && leads.length > 0  ? 
                                                ( leads.map(lead => 
                                                    (
                                            
                                                        <tr key={lead.id}>                                                            
                                                            
                                                            <td>
                                                                <Link to={`/sales/lead-profile/${lead.id}`} className="">
                                                                {lead.name}
                                                                </Link>
                                                            </td>
                                                            <td>{lead.email}</td>
                                                            <td>{lead.contact}</td>
                                                            <td>{lead.location}</td>
                                                            <td>{lead.program}</td>
                                                            <td>{lead.institute}</td>
                                                            <td>{lead.source}</td>

                                                            {filtertype === 'freshlead' ?
                                                            <td>{lead.callername}</td>
                                                            :
                                                            <td>
                                                                {lead.stagename !== "" && lead.stagename !== null ?
                                                                <span class="badge badge-tag badge-purple-light">{lead.stagename}</span>
                                                                :
                                                                    (lead.subdispositionname !== "" && lead.subdispositionname !== null ?
                                                                    <span class="badge badge-tag badge-purple-light">{lead.subdispositionname}</span>
                                                                    :
                                                                        (lead.dispositionname !== "" && lead.dispositionname !== null && lead.dispositionname !== null ?
																        <span class="badge badge-tag badge-purple-light">{lead.dispositionname}</span>
                                                                        :                                                                        
                                                                        <></>   
                                                                        )
                                                                    )
                                                                }
                                                            </td>
                                                            }
                                                            <td>{moment(lead.created_at).format('DD-MM-YYYY h:mm')} </td>
                                                            
                                                        </tr>
                                                    )
                                                ))
                                            
                                            :
                                        
                                                <tr>
                                                    <td colSpan="8">
                                                        <p>No record found...</p>
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    
                                        </tbody>
                                    </table>
                                    
                                </div>
                                
                                

                            </div>
                        </div>
                        
                        {pagecount > 1 ?
                        <div className="pagination-section mt-3">

                            <nav>
                                <Paginate initialPage={perpagedata} pageCount={pagecount} onPageChange={handlePageClick} />
                            </nav>
                        </div>
                        :
                            <></>
                        }

                    </div>
                </div>

            </div>
        </div>

        <ToastContainer />

    </div>
    )
}

export default LeadFilter;